import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { withTranslation } from "react-i18next";
import FlightDelayListWrapper from "./style";
import { useSelector } from "react-redux";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../../helpers/utils";

const FlightDelayList = (props) => {
  const flightCovered = useSelector((state) => state.travel.flightCovered);
  const [delaydetail, setDelayDetail] = useState(flightCovered);

  const onSubmit = () => {
    props.onSelect("" + delaydetail);
  };

  const getPriceElement = (element) => {
    const item = element.paymentDetails.find(
      (ele) => ele.amountType === "GRNDTOT"
    );
    return item
      ? Number(+item.amountValue + +item.amountValue * 0.05).toFixed(2)
      : "";
  };
  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <Dialog
      visible={props.show}
      showHeader={false}
      closable={true}
      modal={true}
      contentClassName="rounded-3"
      maskClassName="prices"
      style={{ color: businessColor }}
    >
      <FlightDelayListWrapper>
        {props.proposal.quoteList.map((ele) => {
          return (
            <div
              key={ele.periodCovered}
              className={
                "field-radiobutton" +
                (delaydetail === ele.periodCovered ? " box" : "")
              }
            >
              <RadioButton
                inputId={ele.periodCovered}
                name={ele.periodCovered}
                value={ele.periodCovered}
                onChange={(e) => setDelayDetail(e.value)}
                checked={delaydetail === ele.periodCovered}
                style={{ color: businessColor }}
              />
              <label htmlFor={ele.periodCovered}>
                <span className="delay-time">
                  {ele.periodCovered} {props.t("mins")}
                </span>
                <span className="delay-amount">{getPriceElement(ele)}</span>
              </label>
            </div>
          );
        })}

        <div className="row">
          <div className="col-6">
            <Button
              type="submit"
              label={props.t("add-to-order")}
              className="p-button-warning"
              // onClick={(e) => op.current.toggle(e)}
              onClick={onSubmit}
            />
          </div>
          <div className="col-6">
            <Button
              label={props.t("cancel")}
              className="p-button-outlined p-button-info"
              onClick={props.onCancel}
            />
          </div>
        </div>
      </FlightDelayListWrapper>
    </Dialog>
  );
};

export default withTranslation()(FlightDelayList);
